import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, NavLink } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { ListItemText, Typography, useTheme } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import { NavHashLink } from "react-router-hash-link";
import file from "../../../files/Resume.pdf";

const Navbar = () => {
  const [state, setState] = useState(false);
  const theme = useTheme();
  const navStyle = makeStyles({
    navIconContainer: {
      [theme.breakpoints.up("sm")]: {
        display: "none",
        color: "white",
      },
    },
    displayName: {
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        justifyContent: "flex-end",
      },
    },
    navItemContainer: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    navItem: {
      textDecoration: "none",
      fontSize: "18px",
      color: "#fff",
      fontWeight: 500,
      marginLeft: "20px",
    },

    mobileNavItem: {
      [theme.breakpoints.up("sm")]: {
        display: "none",
        color: "#fff",
      },
      textDecoration: "none",
      color: "#474747",
    },
  });
  const {
    displayName,
    navItemContainer,
    navItem,
    navIconContainer,
    mobileNavItem,
  } = navStyle();

  return (
    <Box>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          sx={{
            backgroundColor: "#222831",
            px: 15,
            padding: "20px 0",
            color: "#fff",
            boxShadow: "none !important",
          }}
          position="fixed"
          className={displayName}
        >
          <Toolbar>
            <Box className={navIconContainer}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ px: 10, mr: 2, color: "#fff" }}
                onClick={() => setState(true)}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Box sx={{ flexGrow: 1, textAlign: "left" }}>
              <Typography
                sx={{ color: "#fff", fontSize: "40px", mb: 0 }}
                variant="h5"
                gutterBottom
                component="div"
              >
                Borhan Ahmed
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              className={navItemContainer}
            >
              <NavLink to="/" className={navItem}>
                Home
              </NavLink>
              <NavHashLink smooth to="/#aboutMe" className={navItem}>
                About Me
              </NavHashLink>
              <NavHashLink smooth to="/#project" className={navItem}>
                Projects
              </NavHashLink>

              <NavHashLink smooth to="/#contact" className={navItem}>
                Contact
              </NavHashLink>
              <Link className={navItem} to="/blog">
                Blog
              </Link>
              <span style={{ marginLeft: "20px" }} className="navButton">
                <a href={file} download>
                  Download Resume
                </a>
              </span>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      {/* resopnsive dawer  */}
      <Box>
        <React.Fragment>
          <Drawer open={state} onClose={() => setState(false)}>
            <Box sx={{ width: 250 }} role="presentation">
              <List>
                <ListItem button>
                  <ListItemText>
                    <Link className={mobileNavItem} to="/">
                      Home
                    </Link>
                  </ListItemText>
                </ListItem>
                <Divider />

                <ListItem button>
                  <ListItemText>
                    <NavHashLink
                      className={mobileNavItem}
                      smooth
                      to="/#aboutMe"
                    >
                      About Me
                    </NavHashLink>
                  </ListItemText>
                </ListItem>
                <Divider />
                <ListItem button>
                  <ListItemText>
                    <NavHashLink
                      className={mobileNavItem}
                      smooth
                      to="/#project"
                    >
                      Projects
                    </NavHashLink>
                  </ListItemText>
                </ListItem>
                <Divider />
                <ListItem button>
                  <ListItemText>
                    <NavHashLink
                      className={mobileNavItem}
                      smooth
                      to="/#contact"
                    >
                      Contact
                    </NavHashLink>
                  </ListItemText>
                </ListItem>
                <Divider />
                <ListItem button>
                  <ListItemText>
                    <span className="navButtonMobile">
                      <a href={file} download>
                        Resume
                      </a>
                    </span>
                  </ListItemText>
                </ListItem>
                <Divider />
              </List>
            </Box>
          </Drawer>
        </React.Fragment>
      </Box>
    </Box>
  );
};

export default Navbar;
